import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { FunctionComponent } from 'react';

import {
  FolkloreType,
  UserTargetsQuery,
} from '../../../../../apollo/__generated__/graphql';
import { folkloreNameByFolklore } from '../../../../../user/services/user.service';
import { useUserTargetsQuery } from '../../../../hooks/useUserTargetsQuery';

interface UserTargetsTabProps {
  eventId: string;
}

const columns: GridColDef<UserTargetsQuery['userTargets'][number]>[] = [
  {
    field: 'firstname',
    headerName: 'Nom',
    width: 150,
    renderCell: (params) =>
      `${params.row.firstname} ${params.row.lastname?.substring(0, 1)}.`,
  },
  {
    field: 'nickname',
    headerName: 'Surnom',
    width: 150,
  },
  {
    field: 'folklore',
    headerName: 'Folklore',
    renderCell: (params) =>
      folkloreNameByFolklore[params.row.folklore ?? FolkloreType.Other],
    width: 100,
  },
  {
    field: 'studyTown',
    headerName: 'Ville',
    width: 150,
  },
  {
    field: 'studies',
    headerName: 'Fillière',
    width: 150,
  },
];

export const UserTargetsTab: FunctionComponent<UserTargetsTabProps> = ({
  eventId,
}) => {
  const { data: userTargetsData, loading } = useUserTargetsQuery(eventId);

  return (
    <DataGrid
      rows={userTargetsData?.userTargets ?? []}
      columns={columns}
      loading={loading}
    />
  );
};
